import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { Router } from "../../../../../node_modules/@angular/router";
import { TAAConstants } from "../../../../views/constants/taa-constants";
import { HeaderService } from "../../../../views/services/header.service";
import { LandingService } from "../../../../views/services/landing.service";
import { RequestSubmitService } from "../../../../views/services/requestsubmit.service";
import { InternalSendEmailService } from "../../common/services/internalsendemail.service";
import { ConsultantsService } from "../services/consultants.service";

@Component({
  selector: "app-autoapproved",
  templateUrl: "./auto-approved.component.html",
  styleUrls: ["./auto-approved.component.css"]
})
export class AutoApprovedComponent implements OnInit, OnDestroy {
  @Input() searchResult: any;
  @Input() searchClicked: boolean;
  public tableData: any = {};
  public consultantId: any;
  public newConsultantId: any;
  public consultant: any;
  public itemstoUpdate = [];
  public days: any;
  public assignedReviewerName: any;
  public recordUpdate: boolean = false;
  public emptyItem: boolean = false;
  public emptyConsultant: boolean = false;
  public statusCode: any;
  public selectedAll: any;
  public selected = [];
  public consultantDisplay: any;

  constructor(
    private landingService: LandingService,
    public headerService: HeaderService,
    private analystsService: ConsultantsService,
    public internalSendEmailService: InternalSendEmailService,
    public requestSubmitService: RequestSubmitService,
    public taaConstants: TAAConstants,
    public router: Router
  ) {}

  ngOnInit() {
    this.tableData = [];
    if (this.searchClicked === true) {
      this.tableData = this.searchResult;
      if (this.tableData.length > 1) {
        this.processTableData(this.tableData);
      }
    } else {
      this.landingService.getDays().subscribe(response => {
        this.days = response;
        Observable.forkJoin(this.analystsService.getConsultants())
          .finally(() => {
            this.landingService
              .getCompletedInternalScreenData(
                "ap",
                this.days.days,
                this.consultantId
              )
              .subscribe(res => {
                this.tableData = res.body;
                this.processTableData(this.tableData);
              });
          })
          .subscribe(([resp]) => {
            this.consultant = resp;
            for (let i = 0; i < this.consultant.length; i++) {
              if (this.consultant[i].USER_NM === "SYSTEM") {
                this.consultantId = this.consultant[i].CONSULTANT_ID;
                break;
              }
            }
          });
      });
    }
    Observable.forkJoin(this.analystsService.getActiveConsultants()).subscribe(
      ([resp]) => {
        this.consultantDisplay = resp;
        this.consultantDisplay.forEach((item, index, object) => {
          if (item.USER_NM === "SYSTEM") {
            object.splice(index, 1);
          }
        });
        this.consultantDisplay.forEach(element => {
          this.landingService
            .getRequestCountByConsultantId(element.CONSULTANT_ID)
            .subscribe(response => {
              element.Count = response.body;
            });
        });
      }
    );
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getASSIGNED()
      )
    ).subscribe(([assigned]) => {
      this.statusCode = assigned;
    });
  }

  processTableData(tableData: any) {
    this.tableData.forEach(element => {
      if (element.REASONS) {
        element.REASONS = element.REASONS.replace(/\|/g, ",");
      }
      if (element.EXAMINEE_ACCOMMS) {
        element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(/\|/g, ",");
      }
    });
  }

  ngOnDestroy() {
    if (sessionStorage.getItem("tabName")) {
      sessionStorage.setItem("tabName", "");
    }
  }

  sendStudentDetails(examinee: any) {
    const studentDetails = {
      personId: examinee.PERSON_ID,
      requestId: examinee.REQUEST_ID,
      consultantId: examinee.CONSULTANT_ID ? examinee.CONSULTANT_ID : "",
      taaPin: examinee.ACCOMMS_PIN ? examinee.ACCOMMS_PIN : "",
      organizationName: examinee.ORGANIZATION_NM
        ? examinee.ORGANIZATION_NM
        : "",
      firstNm: examinee.PNFIRSTNAME ? examinee.PNFIRSTNAME : "",
      lastNm: examinee.PNLASTNAME ? examinee.PNLASTNAME : ""
    };
    sessionStorage.setItem(
      "internalStudentDetails",
      JSON.stringify(studentDetails)
    );
    sessionStorage.setItem("tabName", "autoApproved");

    this.router.navigate(["/exreqdetails"]);
  }

  onCheckedChange(event, item) {
    if (event) {
      this.itemstoUpdate.push(item);
    } else {
      const index: number = this.itemstoUpdate.indexOf(item);
      if (index !== -1) {
        this.itemstoUpdate.splice(index, 1);
      }
    }
  }

  selectAll() {
    this.itemstoUpdate = [];
    for (let i = 0; i < this.tableData.length; i++) {
      this.tableData[i].selected = this.selectedAll;
      if (this.tableData[i].selected === true) {
        this.itemstoUpdate.push(this.tableData[i]);
      }
    }
  }
  handleAssignTo() {
    this.recordUpdate = false;
    if (this.itemstoUpdate.length === 0) {
      this.emptyConsultant = false;
      this.emptyItem = true;
    } else if (!this.newConsultantId) {
      this.emptyItem = false;
      this.emptyConsultant = true;
    } else {
      const payload: any = [];
      this.emptyConsultant = false;
      this.emptyItem = false;
      const newConsultantId = this.newConsultantId;
      this.consultantDisplay.forEach(item => {
        if (item.CONSULTANT_ID === this.newConsultantId) {
          this.assignedReviewerName = item.USER_NM;
        }
      });
      this.itemstoUpdate.forEach(element => {
        const res = {
          CONSULTANT_ID: this.newConsultantId,
          REQUEST_STATUS_CODE_ID: this.statusCode[0].REQUEST_STATUS_CODE_ID,
          REQUEST_ID: element.REQUEST_ID,
          STATUS_CD: element.STATUS_CD,
          USER_NAME: element.USERNAME,
          assignedReviewerName: this.assignedReviewerName
        };
        payload.push(res);
      });
      const observables = [];
      payload.forEach(item => {
        observables.push(this.landingService.assignTo(item));
      });
      Observable.forkJoin(observables).subscribe(
        ([response]) => {
          this.recordUpdate = true;
          this.consultantId = undefined;
          this.ngOnInit();
          Observable.forkJoin(
            this.internalSendEmailService.requestAssigned(newConsultantId)
          ).subscribe(([resp]) => {
            const rtn: any = resp;
            if (
              rtn.status === 200 ||
              rtn.status === 204 ||
              rtn.status === 201
            ) {
              console.log("Assigned Email sent: " + rtn.status);
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    }
    this.itemstoUpdate = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/auto-approved/auto-approved.component.ts